import { IRobotStep } from "@/types/robot";
import { Button } from "flowbite-react";
import { UseFieldArrayReturn, useFormContext, useWatch } from "react-hook-form";
import {
  MdDelete,
  MdArrowUpward,
  MdArrowDownward,
  MdContentCopy,
  MdPause,
  MdPlayArrow,
} from "react-icons/md";

export const StepControl = ({
  controls,
  index,
}: {
  controls: UseFieldArrayReturn<
    {
      steps: IRobotStep[];
    },
    "steps",
    "id"
  >;
  index: number;
}) => {
  const { control: formControl, setValue } = useFormContext();
  const { fields, insert, remove, swap, update } = controls;
  const disabled = useWatch({
    name: `steps.${index}.disabled`,
    control: formControl,
  });
  return (
    <>
      <Button
        onClick={() => {
          insert(index, {
            type: "click",
            selector: "",
          });
        }}
        className="group-hover:block hidden absolute left-1/2 top-0 -translate-y-1/2 -translate-x-1/2"
      >
        Add A Step Before
      </Button>
      <Button
        onClick={() => {
          insert(index + 1, {
            type: "click",
            selector: "",
          });
        }}
        className="group-hover:block hidden absolute left-1/2 bottom-0 translate-y-1/2 -translate-x-1/2"
      >
        Add A Step After
      </Button>

      <div className="group-hover:flex hidden absolute top-0 right-0 pt-3 pr-3 flex-row gap-2">
        {!disabled && (
          <Button
            color="red"
            onClick={() => {
              setValue(`steps.${index}.disabled`, true);
            }}
          >
            <MdPause />
          </Button>
        )}
        {disabled && (
          <Button
            color="green"
            onClick={() => {
              setValue(`steps.${index}.disabled`, false);
            }}
          >
            <MdPlayArrow />
          </Button>
        )}
        {index !== 0 && (
          <Button
            onClick={() => {
              swap(index, index - 1);
            }}
          >
            <MdArrowUpward />
          </Button>
        )}
        {index !== fields.length - 1 && (
          <Button
            onClick={() => {
              swap(index, index + 1);
            }}
          >
            <MdArrowDownward />
          </Button>
        )}

        <Button
          onClick={() => {
            insert(index + 1, { ...fields[index] });
          }}
        >
          <MdContentCopy />
        </Button>
        <Button
          onClick={() => {
            remove(index);
          }}
        >
          <MdDelete />
        </Button>
      </div>
    </>
  );
};
